/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    dots: { type: 'variant', values: [ true ] },
    size: {
      description: 'used for full-screen spinners',
      type: 'variant',
      values: [ 'large', 'small' ]
    },
    style: { type: 'variant', values: [ 'dots' ] }
  },
  rules: [
    {
      if: { size: 'large' },
      tokens: { dotSize: 12, size: 48, thickness: 4 }
    },
    {
      if: { size: 'small' },
      tokens: { dotSize: 6, size: 24, thickness: 3 }
    }
  ],
  tokens: {
    color: '#2b8000',
    dotSize: 12,
    fullScreenOverlayBackground: 'rgba(255, 255, 255, 0.97)',
    indicatorBackgroundColor: '#e3f6d1',
    size: 48,
    thickness: 4
  }
}
export default theme
